import { render, staticRenderFns } from "./BreadCrumbMenu.vue?vue&type=template&id=642e571a&scoped=true"
import script from "./BreadCrumbMenu.vue?vue&type=script&lang=js"
export * from "./BreadCrumbMenu.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumbMenu.vue?vue&type=style&index=0&id=642e571a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e571a",
  null
  
)

export default component.exports